/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CREATE_ORDER } from "../graphql/createOrder.mutation";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { REGISTER_PAYMENT } from "../graphql/registerPayment.mutation";

const is = require("is_js");
export interface ICreateOrderArgs {
  email: string;
  name: string;
  payOrder: string;
  price: any;
  currency: string;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateOrderTypeMethods extends IPluginMethodMap {
  createOrder(args: any): Promise<any>;
}

export class CreateOrderService implements IAgentPlugin {
  readonly methods: ICreateOrderTypeMethods;

  constructor() {
    this.methods = {
      createOrder: this.createOrder.bind(this),
    };
  }

  async createOrder(args: ICreateOrderArgs) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let variable: any = {
      data: {
        name: args?.name,
        email: args?.email,
        payOrder: args?.payOrder,
        price: args?.price,
        currency: args?.currency,
      },
    };
    if (args?.code) {
      variable = { ...variable, discountCode: args?.code };
    }
    console.log(variable, "========>");
    const storageService = StorageModule.getInstance();

    try {
      if (client) {
        console.log(
          storageService.get("currencyExchangeLocal", "local")?.provider
        );
        if (
          storageService.get("currencyExchangeLocal", "local")?.provider ===
            "CAL" ||
          storageService.get("currencyExchangeLocal", "local")?.provider ===
            "CALKIDS"
        ) {
          console.log(args);
          let variables: any = {
            data: {
              currency: args?.currency,
              amount: args?.price,
              payorder: args?.payOrder,
            },
          };
          if (args?.code) {
            variables = {
              ...variables,
              data: {
                ...variables?.data,
                discountCode: args?.code,
              },
            };
          }
          console.log("variables", variables);
          const resCal = await client.mutate({
            mutation: REGISTER_PAYMENT,
            variables: variables,
            fetchPolicy: "no-cache",
          });

          if (is.existy(resCal?.data?.registerPayment && args?.price != 0)) {
            const paymentUrl =
              resCal?.data?.registerPayment?.data?.session[
                "payment-hosted-url"
              ];
            if (paymentUrl) {
              // Redirect to the payment URL
              window.location.href = paymentUrl;
              console.log(`Redirecting to: ${paymentUrl}`);
              return {
                ...resCal?.data?.registerPayment,
                redirection: true,
              };
            }
            return {
              ...resCal?.data?.registerPayment,
              redirection: false,
            };
          } else if (args?.code && args?.price == 0) {
            return true;
          } else {
            throw new Error("Some Error Occurred");
          }
        } else {
          let variable: any = {
            data: {
              name: args?.name,
              email: args?.email,
              payOrder: args?.payOrder,
              price: args?.price,
              currency: args?.currency,
            },
          };
          if (args?.code) {
            variable = { ...variable, discountCode: args?.code };
          }
          const res = await client.mutate({
            mutation: CREATE_ORDER,
            variables: variable,
            fetchPolicy: "no-cache",
          });
          if (is.existy(res?.data?.getAnglPayRedirectURL?.redirectUrl)) {
            const output = res?.data?.getAnglPayRedirectURL?.redirectUrl;
            window.location.href = output;

            return res?.data?.getAnglPayRedirectURL;
          } else if (
            is.existy(res?.data?.getAnglPayRedirectURL?.sessionId?.sessionId)
          ) {
            const output =
              res?.data?.getAnglPayRedirectURL?.sessionId?.sessionId;
            return {
              sessionId: output,
            };
          } else if (args?.code) {
            return true;
          } else {
            throw new Error("Some Error Occurred");
          }
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
